
import { GetUserDetailsByGuid, UpdateUsersInfo } from "../apiconstants/constants";
import { useState, useEffect } from 'react';
import Axios from "axios";
import { useForm } from "react-hook-form";
import 'react-toastify/dist/ReactToastify.css';
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Swal from "sweetalert2";
import ConsultantLayout from "../commonlayouts/consultantlayout";
import { Link ,useNavigate} from "react-router-dom";
import defaultimg from "../assets/images/icons8-circled-user-male-skin-type-3-100.png"
const ConsultantProfile = () => {
  const [isDisabled, setIsDisabled] = useState(false);
  var apiUrl = {};
  const navigate = useNavigate();
  const { register, handleSubmit, setValue, formState ,reset} = useForm();
  const { errors } = formState
  const { isSubmitting } = formState;
  const[firstName,setFirstName] = useState();
  const[lastName,setLastName] = useState();
  const[companyName,setCompanyName] = useState();
  const[companyURL,setCompanyURL] = useState();
  const[mobileNumber,setMobileNumber] = useState();
const guid= localStorage.getItem("guid")
const roleID= localStorage.getItem("roleID")
const token = localStorage.getItem("jwtToken");

  const GetCandidateList = () => {
    const GetapiUrl = `${GetUserDetailsByGuid.APIURL}/${guid}`;
    Axios.get(GetapiUrl, {
  headers: {
    "Authorization": `Bearer ${token}`
  }
}).then((result) => {
        setFirstName(result.data[0].firstName)
        setLastName(result.data[0].lastName)
        setMobileNumber(result.data[0].mobileNumber)
        setValue("firstName",result.data[0].firstName)
        setValue("lastName",result.data[0].lastName)
        setValue("mobileNumber",result.data[0].mobileNumber)
        setValue("companyName",result.data[0].companyName)
        setValue("companyURL",result.data[0].companyURL)
      })
    }

 
  const UpdateData = async(data) => {
    const loggedInUser = localStorage.getItem("userID");
       const params={
        userID: loggedInUser,
        firstName: data.firstName,
        lastName: data.lastName,
        companyURL:data.companyURL,
        companyName: data.companyName,
        mobileNumber: data.mobileNumber
    }
  
    apiUrl = UpdateUsersInfo.APIURL;
    Axios.put(apiUrl, params,{
    headers: {
      "Authorization": `Bearer ${token}`,
      "Content-Type": "multipart/form-data"
    }
  })  
      .then((result) => {
             if (result.data.message === ' Record upadted successfully') {
          // GetConsultantProfile();
        Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'Updated Successfully ',
            showConfirmButton: false,
            timer: 5000
          })
          // toast.success('Data Saving', {autoClose:5000})
        //   if(roleID==2){
        //   navigate("/Employer/Dashboard")}
        //  else  if(roleID==3){
        //     navigate("/Employer/UserDashboard")}
        //   else if(roleID==4){
        //     navigate("/Employer/CEMDashboard")}
        // }
        navigateToDashboard();
      }
        else {
          // toast.error('Issue with data format', {autoClose:5000})
          Swal.fire({
            position: 'center',
            icon: 'error',
            title: 'Add correct Details',
            showConfirmButton: false,
            timer: 5000
          })
        }

      }).catch(
        function (error) {
          console.log("Error" + error)
        })

  }
  const navigateToDashboard = () => {
    if (roleID === '2') {
      navigate("/Employer/Dashboard");
    } else if (roleID === '3') {
      navigate("/Employer/UserDashboard");
    } else if (roleID === '4') {
      navigate("/Employer/CEMDashboard");
    } else {
      navigate("/");
    }
  };
  const handleLogoutAndNavigate =()=>{
    localStorage.clear();
    sessionStorage.clear();
    navigate("/account/ForgotPassword");
  }

  const onSubmit = (data, e) => {
    e.preventDefault();

      UpdateData(data);
  return new Promise(resolve => {
      setTimeout(() => {
        resolve();
      }, 5000);
    });

  }

  

  useEffect(() => {
GetCandidateList();

  }, []);

  return (
    <ConsultantLayout>
      <section>
        <div className="container mt-4 pb-5">

          {/* <h2 style={{color:"#00a7ac",textAlign:"center"}}>
            Profile
          </h2> */}
          <div className='row'>
           <div className='col-sm-12 col-lg-6 col-xl-6 col-md-6  mt-3'>
           <h2 className="" style={{color:"#00a7ac"}} >My Profile</h2>
      </div>
           
           <div className='col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-3 ' >
            <div style={{float:"right"}}>
            <OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}> Change Password</Tooltip>)}> 

                       <Link to="/account/ForgotPassword"> <button className="btn btn-primary mr-3" onClick={handleLogoutAndNavigate}  btn-ype="button">Change Password</button>
           </Link>
           </OverlayTrigger>
           
  
          </div>
           </div>
           </div>
<hr/>
<div class="card shadow-lg mt-5 p-5" style={{border:"none"}}>
                        
                        <div class="row mt-2">
<form onSubmit={handleSubmit(onSubmit)} >
          <div className="row mt-2 p-0">
            <div className="col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-3">
              <input
                placeholder='ConsultantID'
                type="hidden"
                name="subConsultantID"

                {...register("subConsultantID")}
                

              />
   <div className="col-2">
      
      

</div>
              <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> First Name</Tooltip>)}>
                <input type="text" name="firstName" disabled defaultValue={firstName} {...register("firstName")} placeholder="First Name" className={`form-control basic-form `} />
              </OverlayTrigger>
              {/* <div className="invalid-feedback"> {errors.consultantName?.message}</div> */}
            <div className="mt-4">      
                    <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>  Last Name</Tooltip>)}>
                <input type="lastName"  name="lastName" disabled defaultValue={lastName} {...register("lastName")}  placeholder="Last Name  " className={`form-control basic-form`} />
              </OverlayTrigger>
              <div className="invalid-feedback">{errors.lastName?.message}</div>
         
         </div>
         <div className="mt-4"> 
         <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Company Name</Tooltip>)}>
                <input type="text" name="companyName"  {...register("companyName", { required: "Company Name required" })} placeholder="Company Name" className={`form-control basic-form ${errors.companyName ? 'is-invalid' : ''}`} />
              </OverlayTrigger>
              <div className="invalid-feedback"> {errors.companyName  ?.message}</div>
</div>
            </div>
            <div className="col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-3">
              <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Mobile Number</Tooltip>)}>

                <input
                  placeholder='Mobile Number'
                  type="Number"
                  min="0"
                  title=''
                  defaultValue={mobileNumber}
                  name="mobileNumber"
                 disabled
                  {...register("mobileNumber")}
                  className={`form-control basic-form`}

                />
              </OverlayTrigger>
             
              <div className="mt-4"> 
              <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>webiste url</Tooltip>)}>
                <input type="text" title="" name="companyURL" {...register("companyURL", { required: "company URL required" })} placeholder="company URL " className={`form-control basic-form ${errors.companyURL ? 'is-invalid' : ''}`} />
              </OverlayTrigger>
              <div className="invalid-feedback">{errors.companyURL?.message}</div>
         </div>
           </div>

          </div>
         
    
          <div className="row mt-4 p-0">
            <div className="col-12">
             
            {/* <Link to="/Employer/Dashboard">  */}
             {/* <button  style={{float:"right"}}disabled={isSubmitting || isDisabled} className="btn btn-primary ">
                Cancel
              </button> */}
              <button type="button" style={{ float: "right" }} onClick={navigateToDashboard} disabled={isSubmitting || isDisabled} className="btn btn-primary">
                      Cancel
                    </button>
              {/* </Link> */}
              <button style={{float:"right"}} disabled={isSubmitting || isDisabled} className="btn btn-primary mr-3">
                {isSubmitting && <span className="spinner-border spinner-border-sm mr-1"></span>}
                Update
              </button> &nbsp;&nbsp;&nbsp;
            </div>


          </div>

        </form>
                </div>
</div>
</div>


      </section>
    </ConsultantLayout>
  );
}

export default ConsultantProfile;